import createIcon from '../../createIcon';

/**
 * @component @name Fence
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTJWMTBIMTlWN0wxNiA0TDE0IDZMMTIgNEwxMCA2TDggNEw1IDdWMTBIM1YxMkg1VjE0SDNWMTZINVYyMEgxOVYxNkgyMVYxNEgxOVYxMkgyMVpNMTYgNi44M0wxNyA3LjgzVjEwSDE1VjcuODNMMTYgNi44M1pNMTIgNi44M0wxMyA3LjgzVjEwSDExVjcuODNMMTIgNi44M1pNMTEgMTRWMTJIMTNWMTRIMTFaTTEzIDE2VjE4SDExVjE2SDEzWk03IDcuODNMOCA2LjgzTDkgNy44M1YxMEg3VjcuODNaTTcgMTJIOVYxNEg3VjEyWk03IDE2SDlWMThIN1YxNlpNMTcgMThIMTVWMTZIMTdWMThaTTE3IDE0SDE1VjEySDE3VjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fence = createIcon('Fence', [
  [
    'path',
    {
      d: 'M21 12V10H19V7L16 4L14 6L12 4L10 6L8 4L5 7V10H3V12H5V14H3V16H5V20H19V16H21V14H19V12H21ZM16 6.83L17 7.83V10H15V7.83L16 6.83ZM12 6.83L13 7.83V10H11V7.83L12 6.83ZM11 14V12H13V14H11ZM13 16V18H11V16H13ZM7 7.83L8 6.83L9 7.83V10H7V7.83ZM7 12H9V14H7V12ZM7 16H9V18H7V16ZM17 18H15V16H17V18ZM17 14H15V12H17V14Z',
      key: '1ojzll',
    },
  ],
]);

export default Fence;
